/** IDs de sedes en BD para tablas de tarifas vigentes (2026). */
export const VACACION_SEDE_ID = {
  PORTALES_DEL_SOL: 1,
  SEDE_TOCAIMA: 2,
};

export const tarifaSedeTocaima = {
  titulo: 'Sede vacacional Tocaima — valor por día y por habitación',
  nota: 'En días festivos se aplica la tarifa de fin de semana. Niños de 1 a 5 años: 50% de la tarifa; desde los 6 años: 100%.',
  columnas: ['Estadía', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
  filas: [
    {
      tipo: 'Asociados',
      dias: [49000, 49000, 49000, 49000, 55000, 55000, 55000],
    },
    {
      tipo: 'No asociados',
      dias: [55000, 55000, 55000, 55000, 62000, 62000, 62000],
    },
  ],
  pago: ['50% al momento de la reserva', '50% un día antes de la fecha de llegada'],
};

export const tarifaPortalesDelSol = {
  titulo: 'Casas Portales del Sol — Tocaima',
  nota: 'Valores de referencia vigentes 2026. Consulta disponibilidad y condiciones en la cooperativa.',
  columnas: ['Estadía', 'Valor', 'Adicional', 'Total 2026'],
  casas: [
    {
      nombre: 'Casa 1',
      filas: [
        { tipo: 'Asociados', valor: 500000, adicional: 115000, total: 615000 },
        { tipo: 'No asociados', valor: 550000, adicional: 126500, total: 676500 },
      ],
    },
    {
      nombre: 'Casa 2',
      filas: [
        { tipo: 'Asociados', valor: 450000, adicional: 103500, total: 450000 },
        { tipo: 'No asociados', valor: 500000, adicional: 115000, total: 550000 },
      ],
    },
  ],
};

/** @returns {'habitacion' | 'portales' | null} */
export function getTarifaVariantBySedeId(sedeId) {
  const id = Number(sedeId);
  if (id === VACACION_SEDE_ID.SEDE_TOCAIMA) return 'habitacion';
  if (id === VACACION_SEDE_ID.PORTALES_DEL_SOL) return 'portales';
  return null;
}

export function getTarifasForSedeId(sedeId) {
  const variant = getTarifaVariantBySedeId(sedeId);
  if (variant === 'habitacion') return tarifaSedeTocaima;
  if (variant === 'portales') return tarifaPortalesDelSol;
  return null;
}
